<template>
  <section>
    <THeading
      :level="3"
      tag="h3"
      class="mb-2"
    >
      {{ rvFullModelLabel }}
    </THeading>

    <AppCollapsibleContent
      v-if="rvRVDescription"
      :content="rvRVDescription"
      more-button-variant="link"
      is-show-more-button
    />

    <TGrid
      has-vertical-gap
      class="mt-6"
    >
      <RvRentalDetailItem
        :label="t('rv.sleeps')"
        :value="rvGuests"
      />

      <template v-if="rvIsMotorized">
        <RvRentalDetailItem
          v-if="rvSeatbeltTwoPoint && rvSeatbeltTwoPoint > 0"
          :label="t('pages.owner.editRV.details.seatbeltTwoPoint')"
          :value="rvSeatbeltTwoPoint"
        />
        <RvRentalDetailItem
          v-if="rvSeatbeltThreePoint && rvSeatbeltThreePoint > 0"
          :label="t('pages.owner.editRV.details.seatbeltThreePoint')"
          :value="rvSeatbeltThreePoint"
        />
      </template>
      <RvRentalDetailItem
        v-if="rvSlideouts"
        :label="t('rv.slideouts')"
        :value="rvSlideouts"
      />
      <RvRentalDetailItem
        v-if="rvIsMotorized && rvLength"
        :label="t('rv.length')"
        :value="rvLength"
        :unit="t('unit.ft')"
      />

      <template v-if="rvIsTowable">
        <RvRentalDetailItem
          v-if="rvWeight"
          :label="t('rv.weight')"
          :value="rvWeight"
          :unit="t('unit.lbs')"
        />

        <RvRentalDetailItem
          v-if="rvHitchSize"
          :label="t('rv.hitchSize')"
          :value="rvHitchSize"
        />

        <RvRentalDetailItem
          v-if="rvHitchWeight"
          :label="t('rv.hitchWeight')"
          :value="rvHitchWeight"
          :unit="t('unit.lbs')"
        />

        <RvRentalDetailItem
          v-if="rvLength && rvLength > 0"
          :label="t('rv.length')"
          :value="rvLength"
          :unit="t('unit.ft')"
        />
      </template>

      <RvRentalDetailItem
        v-if="rvIsMotorized && rvFuelType"
        :label="t('fuelType')"
        :value="t(rvFuelType)"
      />

      <TGridItem
        :cols="6"
        :lg="4"
      >
        <div class="text-gray-500">
          {{ t('typeOfRv') }}
        </div>
        <strong>{{ t(rvLocalizedRVType) }}</strong>
      </TGridItem>
    </TGrid>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()

const {
  rvFuelType,
  rvFullModelLabel,
  rvGuests,
  rvHitchSize,
  rvHitchWeight,
  rvIsMotorized,
  rvIsTowable,
  rvLength,
  rvLocalizedRVType,
  rvRVDescription,
  rvSeatbeltThreePoint,
  rvSeatbeltTwoPoint,
  rvSlideouts,
  rvWeight,
} = useRvDetails()
</script>

<i18n src="~~/i18n/locales/common/rv/accommodations.json" lang="json" />

<i18n src="~~/i18n/locales/common/units.json" lang="json" />

<i18n lang="json">
{
  "en": {
    "fuelType": "Fuel type",
    "typeOfRv": "Type of RV"
  },
  "fr": {
    "fuelType": "Type de carburant",
    "typeOfRv": "Type de VR"
  }
}
</i18n>
